module.exports = __webpack_public_path__ + "img/6.276ecf30.svg";